/* unplugin-vue-components disabled */import { render } from "./SafeAreaBottom.vue?vue&type=template&id=1cefd7a1"
import script from "./SafeAreaBottom.vue?vue&type=script&lang=js"
export * from "./SafeAreaBottom.vue?vue&type=script&lang=js"

import "./SafeAreaBottom.vue?vue&type=style&index=0&id=1cefd7a1&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__